var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdienthoai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8267 1.33337H5.17332C3.33332 1.33337 2.66666 2.00004 2.66666 3.87337V12.1267C2.66666 14 3.33332 14.6667 5.17332 14.6667H10.82C12.6667 14.6667 13.3333 14 13.3333 12.1267V3.87337C13.3333 2.00004 12.6667 1.33337 10.8267 1.33337ZM7.99999 12.8667C7.35999 12.8667 6.83332 12.34 6.83332 11.7C6.83332 11.06 7.35999 10.5334 7.99999 10.5334C8.63999 10.5334 9.16666 11.06 9.16666 11.7C9.16666 12.34 8.63999 12.8667 7.99999 12.8667ZM9.33332 4.16671H6.66666C6.39332 4.16671 6.16666 3.94004 6.16666 3.66671C6.16666 3.39337 6.39332 3.16671 6.66666 3.16671H9.33332C9.60666 3.16671 9.83332 3.39337 9.83332 3.66671C9.83332 3.94004 9.60666 4.16671 9.33332 4.16671Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdienthoai);
export default __webpack_public_path__ + "static/media/idienthoai.085176863438141d1c42b5b7163cd40e.svg";
export { ForwardRef as ReactComponent };